import type { TablePagerLabels } from '@croissants/ui';
import { useT } from '../i18n/index';

/**
 * The pager's words. One lookup for the whole portal.
 *
 * It stays in the app rather than moving into `packages/ui` beside `TablePager`
 * itself, for the reason the table paragraph of `docs/design-system.html` gives:
 * it reads THIS app's catalogue, and the partner portal keeps its own copy
 * reading that one. The component takes the strings; only the lookup is per
 * portal.
 *
 * It lived in `components/PagedTable.tsx` until every table on this portal moved
 * onto `TableUnit`, at which point the rest of that file had nothing left to do.
 */
export function usePagerLabels(): TablePagerLabels {
  const t = useT();
  return {
    pagination: t('table.pagination'),
    first: t('table.first'),
    previous: t('table.previous'),
    next: t('table.next'),
    last: t('table.last'),
    range: (from, to, total) => t('table.range', { from, to, total }),
  };
}
